import React from 'react';
import { useNavigate } from 'react-router-dom';
import ClientLayout from '../../components/layout/ClientLayout';

const SitePreparationPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <ClientLayout>
      <div className="w-full min-h-screen bg-white">
        <div className="max-w-2xl w-full mx-auto px-4 sm:px-6 lg:px-8 relative pt-8">
          <div className="flex items-center justify-center min-h-[600px]">
            <div className="text-center w-full">
              <div className="mb-8">
                <svg
                  className="mx-auto h-16 w-16 sm:h-20 sm:w-20 md:h-24 md:w-24 text-blue-500"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 9.172V5L8 4z"
                  />
                </svg>
              </div>

              <h1 className="text-slate-800 text-2xl sm:text-3xl md:text-4xl font-extrabold font-['Pretendard'] mb-4 px-4">
                서비스 준비중입니다
              </h1>

              <p className="text-slate-600 text-base sm:text-lg md:text-xl font-normal font-['Pretendard'] mb-8 leading-relaxed px-4">
                현재 해당 기능은 준비중입니다.<br />
                빠른 시일 내에 서비스를 제공할 수 있도록 최선을 다하겠습니다.
              </p>

              <div className="space-y-4 px-4">
                <button
                  onClick={() => navigate('/')}
                  className="w-full max-w-xs h-12 bg-blue-500 hover:bg-blue-600 rounded-sm transition-colors mx-auto"
                >
                  <span className="text-white text-base sm:text-lg font-medium font-['Pretendard']">
                    메인으로 돌아가기
                  </span>
                </button>

                <div className="mt-6 text-slate-500 text-xs sm:text-sm font-normal font-['Pretendard']">
                  문의사항이 있으시면 부산항신항시설관리센터로 연락주시기 바랍니다.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ClientLayout>
  );
};

export default SitePreparationPage; 